export default __webpack_public_path__ + "static/media/epilogue.79045a7a.md";